import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { Router } from "@angular/router";
import { DataTableDirectives } from "angular2-datatable/datatable";
import { FORM_DIRECTIVES, FORM_PROVIDERS, FormControl, FormGroup, REACTIVE_FORM_DIRECTIVES } from "@angular/forms";
import { AlertComponent, BS_VIEW_PROVIDERS, MODAL_DIRECTIVES, ModalDirective, TYPEAHEAD_DIRECTIVES } from "ng2-bootstrap/ng2-bootstrap";
import { PaginatePipe, PaginationControlsCmp, PaginationService } from "ng2-pagination";
import { NavigationService } from "../service/navigation.service";
import { InfractionsService } from "../service/infractions.service";
import { BankService } from "../service/bank.service";
import { CitiesService } from "../service/cities.service";
import { Infraction } from "../domain/infraction";
import { Vehicle } from "../domain/vehicle";
import { Address } from "../domain/address";
import { Bank } from "../domain/bank";
import { Page } from "../domain/page";
import { City } from "../domain/city";
import { InfractionState } from "../domain/infractionState";
import { LoginService } from "../service/login.service";
import "rxjs/Rx";
import { FILE_UPLOAD_DIRECTIVES, FileUploader } from "ng2-file-upload/ng2-file-upload";
import { FileUploaderCustom } from "ng2-file-upload/components/file-upload/FileUploaderCustom";
import { AmountFormat, DATE_VALID_CHARACTERS, DATE_VALIDATOR, DEFAULT_ERROR_MESSAGES, FILE_MAX_SIZE, VALID_MIME_TYPES } from "../validators/validators";
import { Tab } from "../tabs/tab.component";
import { Tabs } from "../tabs/tabs.component";

@Component({
    selector: 'infractions-panel',
    template: require('./infractions.panel.component.html'),
    styles: [require('./infractions.panel.component.css')],
    directives: [
        DataTableDirectives,
        FORM_DIRECTIVES,
        REACTIVE_FORM_DIRECTIVES,
        AlertComponent,
        /*DATEPICKER_DIRECTIVES,*/
        MODAL_DIRECTIVES,
        PaginationControlsCmp,
        /*MyDatePicker,*/
        TYPEAHEAD_DIRECTIVES,
        FILE_UPLOAD_DIRECTIVES,
        Tabs,
        Tab
    ],
    providers: [
        FORM_PROVIDERS,
        PaginationService
    ],
    viewProviders: [BS_VIEW_PROVIDERS],
    pipes: [
        PaginatePipe,
        AmountFormat
    ],
})
export class InfractionsPanelComponent implements OnInit, AfterViewInit {

    private data: Infraction[];
    private sortMode: boolean;

    public errorMessages: any;

    public act: string;
    public cuit: string;
    public patent: string;
    public bankId: string;
    public city: City;
    public bank: Bank;

    public creationDateSince: string;
    public creationDateUntil: string;

    public state: InfractionState;
    public stateTodos: InfractionState;
    public bankTodos: Bank;

    private banks: Bank[];
    private states: InfractionState[];
    private citiesDataSource: Observable<any>;

    public error: any;
    public reportMessage: string;

    private currentPage: Page;

    public form: FormGroup;

    public itemsPerPage: number;
    public loading: boolean;
    public page: number;
    public total: number;

    public withActs: boolean;
    public isBeforeUpload: boolean;

    public infractionSelected: Infraction;

    /*myDatePickerOptions:any;*/

    private citySelected: City;
    public typeaheadCitiesNoResults: boolean;

    public canEditInfraction: boolean;
    public canViewInfractionAsClient: boolean;
    public canDeleteInfraction: boolean;
    public canViewInfraction: boolean;

    public showFilters: boolean;
    public sendMailSuccess: boolean;
    public sendMailError: boolean;

    public oneClickBulkLoadPay: boolean;
    public oneClickBulkLoad: boolean;
    public oneClickBulkLoadUpdate: boolean;

    public isBankGalicia: boolean;

    @ViewChild('bulkLoadInfractionPay') bulkLoadInfractionPay: ElementRef;
    @ViewChild('bulkLoadInfraction') bulkLoadInfraction: ElementRef;
    @ViewChild('bulkLoadUpdateInfraction') bulkLoadUpdateInfraction: ElementRef;
    /*@ViewChild('bulkLoadImage') bulkLoadImage:ElementRef;*/
    @ViewChild('bulkLoadInfractionPayModal') bulkLoadInfractionPayModal: ModalDirective;
    @ViewChild('bulkLoadInfractionModal') bulkLoadInfractionModal: ModalDirective;
    @ViewChild('bulkLoadUpdateInfractionModal') bulkLoadUpdateInfractionModal: ModalDirective;
    public errorsBulkLoad: string[];

    @ViewChild('imgNotFound') imgNotFound: ElementRef;
    @ViewChild('infractionActImage') infractionAct: ElementRef;

    @ViewChild('download') download: ElementRef;

    public uploaderBulkLoadPay: FileUploader;
    public hasBulkLoadPayDropZoneOver: boolean;

    public uploaderBulkLoad: FileUploaderCustom;
    public hasBulkLoadDropZoneOver: boolean;

    public uploaderBulkLoadUpdate: FileUploaderCustom;
    public hasBulkLoadUpdateDropZoneOver: boolean;

    private pA: any;
    private pB: any;

    constructor(private router: Router,
        private infractionsService: InfractionsService,
        private bankService: BankService,
        private citiesService: CitiesService,
        private navigationService: NavigationService,
        private loginService: LoginService) {
        /* this.myDatePickerOptions = {dateFormat: 'dd/mm/yyyy'};*/
        this.init();

        bankService.getBanks().subscribe(
            this.setBanks.bind(this),
            () => {
                this.bindError('Ocurrió un error al obtener los bancos.')
            });

        infractionsService.getInfractionStates().subscribe(
            this.setStates.bind(this),
            () => {
                this.bindError('Ocurrió un error al obtener los estados de infracciones.')
            });

        /*Descomentar si se quiere filtrar en cuanto el formulario cambie*/
        /*this.form.valueChanges
         .debounceTime(400)
         .subscribe(this.find.bind(this));*/

        this.citiesDataSource = Observable.create((observer: any) => {
            // Runs on every search
            observer.next(this.city);
        }).mergeMap((token: string) => this.citiesService.getCitiesByName(token));
    }

    private init(): void {
        this.data = [];
        this.sortMode = null;

        this.errorMessages = DEFAULT_ERROR_MESSAGES;

        this.stateTodos = new InfractionState('', 'TODOS');
        this.state = this.stateTodos;
        this.bankTodos = new Bank();
        this.bankTodos.id = '';
        this.bankTodos.name = 'TODOS';
        this.bank = this.bankTodos;

        this.banks = [];
        this.states = [];

        this.itemsPerPage = 10;
        this.loading = false;
        this.page = 1;
        this.total = 0;

        this.withActs = false;

        this.canEditInfraction = false;
        this.canViewInfractionAsClient = false;
        this.canDeleteInfraction = false;
        this.canViewInfraction = false;
        this.isBankGalicia = false;

        this.showFilters = false;
        this.sendMailSuccess = false;
        this.sendMailError = false;

        this.createUploaderBulkLoad();
        this.createUploaderBulkLoadPay();
        this.createUploaderBulkLoadUpdate();

        this.errorsBulkLoad = [];

        this.form = new FormGroup({
            act: new FormControl(),
            patent: new FormControl(),
            bank: new FormControl(),
            city: new FormControl(),
            cuit: new FormControl(),
            state: new FormControl(),
            creationDateSince: new FormControl(this.creationDateSince, [DATE_VALID_CHARACTERS, DATE_VALIDATOR, this.validateCreationDateSinceRequired.bind(this)]),
            creationDateUntil: new FormControl(this.creationDateUntil, [DATE_VALID_CHARACTERS, DATE_VALIDATOR, this.validateCreationDateUntilRequired.bind(this)]),
            itemsPerPage: new FormControl(),

            withActs: new FormControl()
        });

        this.isBeforeUpload = true;

        this.oneClickBulkLoadPay = false;
        this.oneClickBulkLoad = false;
        this.oneClickBulkLoadUpdate = false;
    }

    private validateCreationDateSinceRequired(group: FormControl): any {
        if (!this.creationDateSince && this.creationDateUntil) {
            this.form.controls['creationDateUntil'].updateValueAndValidity();
            return {
                required: true
            };
        }
        return null;
    }

    private validateCreationDateUntilRequired(group: FormControl): any {
        if (this.creationDateSince && !this.creationDateUntil) {
            this.form.controls['creationDateSince'].updateValueAndValidity();
            return {
                required: true
            };
        }
        return null;
    }

    public triggerCreateDateValidators(): void {
        this.form.controls['creationDateSince'].updateValueAndValidity();
        this.form.controls['creationDateUntil'].updateValueAndValidity();
    }

    private setBanks(banks: Bank[]): void {
        this.banks = banks;
        if (banks.length == 1) {
            this.bank = banks[0];
        }
    }

    private setStates(states: InfractionState[]): void {
        this.states = states;
        if (states.length == 1) {
            this.state = states[0];
        }
    }

    public find(): void {
        this.getData(1);
    }

    private createFilter(): Infraction {
        let filter = new Infraction();
        filter.vehicle = new Vehicle();
        filter.actNumber = this.act;
        filter.vehicle.patent = this.patent;
        filter.vehicle.contract.cuit = this.cuit;
        if (this.bankId) {
            filter.vehicle.contract.bank.id = this.bankId;
        } else {
            filter.vehicle.contract.bank = this.bank;
        }
        if (this.city && this.citySelected) {
            filter.address = new Address(null);
            filter.address.city = this.citySelected;
        }

        filter.state = this.state;
        filter.creationDateSince = this.creationDateSince;
        filter.creationDateUntil = this.creationDateUntil;
        return filter;
    }

    public filterEmpty(): boolean {
        return !(this.act || this.patent || this.cuit || this.city || this.bank.id !== '' || this.state.id !== ''
            || (this.creationDateSince && this.creationDateUntil));
    }

    private getData(page: number): void {
        this.error = null;
        this.reportMessage = null;
        if (this.itemsPerPage != null && this.itemsPerPage > 0) {
            if (!this.filterEmpty() && this.form.valid) {
                this.loading = true;

                this.infractionsService.findInfractions(this.createFilter(), page, this.itemsPerPage).subscribe(
                    (data) => {
                        console.log(data);
                        this.refreshData(data);
                        if (this.sortMode != null)
                            this.sortPage();
                        this.page = page;
                    },
                    () => {
                        this.bindError('Ocurrió un error al cargar las infracciones.');
                    });
            }
        } else {
            this.bindError('Cantidad de ítems no válida.');
        }
    }

    private refreshData(page: Page): void {
        this.data = page.content.map(
            (infraction) => {
                let i = new Infraction(infraction);
                if (i.hasBankGalicia) {
                    console.log("SI TIENE BANCO GALICIA");
                    this.isBankGalicia = true;
                }
                return i;
            }
        );
        /*page.content;*/
        this.currentPage = page;
        this.total = page.totalElements;
        this.loading = false;
    }

    public removeItem(deleteModal: any): void {
        this.error = null;
        this.infractionsService.delete(this.infractionSelected.id).subscribe(
            () => {
                deleteModal.hide();
                this.removeItemFromView(this.infractionSelected);
            },
            () => {
                this.bindError('Ocurrió un error al eliminar infraccion.');
            });
    }

    public removeItemFromView(infraction: Infraction): void {
        let index = this.data.indexOf(infraction);
        if (index > -1) {
            this.data.splice(index, 1);
        }
        this.infractionSelected = null;
    }

    public editItem(item: Infraction, event: any): void {
        event.preventDefault();
        this.navigationService.setBackParameters({ tabSelected: 'infractions' });
        this.router.navigate(['app/home/editInfraction', item.id]);
    }

    public create(event: any): void {
        event.preventDefault();
        this.navigationService.setBackParameters({ tabSelected: 'infractions' });
        this.router.navigate(['app/home/createInfraction']);
    }

    public downloadClientInfractions(): void {
        this.error = null;
        this.loading = true;
        this.reportMessage = 'Creando reporte...';
        if (this.withActs) {
            if (this.total < 3000) {
                this.reportMessage = 'Creando reporte...';
            }
        }
        let url = window.location.origin +
            InfractionsService.getURLFilterInfractions(this.createFilter(), this.page, this.itemsPerPage, this.withActs);
        window.location.href = url;
        this.loading = false;
    }

    public downloadFilterInfractions(): void {
        this.error = null;
        if (!this.filterEmpty()) {
            this.loading = true;

            this.reportMessage = 'Creando reporte...';
            if (this.withActs) {
                if (this.total < 3000) {
                    /*TODO: muchas imágenes puede que rompa por timeout*/
                    this.reportMessage = 'Creando reporte...';
                }
            }

            /*
             * Se exportan todos las infracciones que cumplan con el filtro.
             * Sólo las infracciones de la página actual se descargan.
             * Opcional: descarga de imágenes de actas.
             */
            let url = window.location.origin +
                InfractionsService.getURLFilterInfractions(this.createFilter(), this.page, this.itemsPerPage, this.withActs);
            window.location.href = url;

            this.loading = false;
            /*this.infractionsService.downloadFilterInfractions(this.createFilter(), this.page, this.itemsPerPage, this.withActs).subscribe(
             (data:Response) => {
             this.loading = false;
             if (data.url == null) {
             if (navigator.appName == 'Microsoft Internet Explorer' || !!(navigator.userAgent.match(/Trident/) ||
             navigator.userAgent.match(/rv 11/))) {
             window.location.href = this.infractionsService
             .downloadFilterInfractionsForIE(this.createFilter(), this.page, this.itemsPerPage, this.withActs);
             } else {
             this.bindError('Ocurrió un error al descargar las infracciones filtradas.');
             }
             } else {
             window.location.href = data.url;
             }
             },
             () => {
             this.bindError('Ocurrió un error al descargar los infracciones filtradas.');
             });*/
        }
    }

    public close(saved: Infraction): void {
        if (saved) {
            this.find();
        }
    }

    public getPage(page: number): void {
        this.getData(page);
    }

    public onCitySelected(city: any): void {
        this.citySelected = city.item;
    }

    public changeCitiesTypeaheadNoResults(e: boolean): void {
        this.typeaheadCitiesNoResults = e;
    }

    public ngOnInit() {
        let userLogged = this.loginService.getUserLogged();
        console.log("hola ");
        this.canEditInfraction = userLogged.isActionAllowed('INFRACTIONS', 'EDIT', 'INFRACTIONS');
        //this.canViewInfractionAsClient = userLogged.isClient();
        this.canViewInfractionAsClient = userLogged.isPatent();
        this.canDeleteInfraction = userLogged.isActionAllowed('INFRACTIONS', 'DELETE', 'INFRACTIONS');
        this.canViewInfraction = userLogged.isActionAllowed('INFRACTIONS', 'VIEW', 'INFRACTIONS');
        console.log(userLogged);
        this.isBankGalicia = userLogged.isGaliciaBank();

        if (userLogged.rol.client) {
            if (userLogged.cuit) {
                this.cuit = userLogged.username;
            } else {
                this.patent = userLogged.username;
            }
            this.bankId = userLogged.bank.id;
            this.showFilters = false;
            this.find();
        } else {
            this.showFilters = true;
        }
    }

    public createUploaderBulkLoad(): void {
        this.uploaderBulkLoad = new FileUploaderCustom({
            url: 'infraction/bulkLoad',
            /*allowedMimeType: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
             'image/jpeg', 'image/gif', 'image/png']*/
            allowedMimeType: VALID_MIME_TYPES,
            maxFileSize: FILE_MAX_SIZE
        });

        this.hasBulkLoadDropZoneOver = false;

        this.uploaderBulkLoad.onErrorItem = (item: any, response: any, status: any, headers: any) => {
            this.reportMessage = null;
            if (status == 400) {//BAD_REQUEST
                if (response == "") {
                    this.errorsBulkLoad = [];
                    this.errorsBulkLoad[0] = "Archivo de carga masiva de infracciones no válido.";
                } else {
                    this.errorsBulkLoad = JSON.parse(response);

                    window.location.href = window.location.origin +
                        InfractionsService.getURLInfractionBulkload(this.errorsBulkLoad[this.errorsBulkLoad.length - 1]);

                    this.errorsBulkLoad.splice(-1, 1);
                    this.errorsBulkLoad.unshift("Carga masiva de infracciones cancelada.");
                }
            }
            this.oneClickBulkLoad = false;
            this.showBulkLoadModal();
        };

        this.uploaderBulkLoad.onSuccessItem = (item: any, response: any, status: any, headers: any) => {
            this.reportMessage = null;
            if (status == 200) {//OK
                let message = response.split("|");
                this.errorsBulkLoad = [];
                this.errorsBulkLoad[0] = message[0];

                if (message.length > 1) {
                    window.location.href = window.location.origin +
                        InfractionsService.getURLInfractionBulkload(message[1]);
                }
            } else if (status == 400) {//BAD_REQUEST
                if (response == "") {
                    this.errorsBulkLoad = [];
                    this.errorsBulkLoad[0] = "Archivo de carga masiva de infracciones no válido.";
                } else {
                    this.errorsBulkLoad = JSON.parse(response);

                    window.location.href = window.location.origin +
                        InfractionsService.getURLInfractionBulkload(this.errorsBulkLoad[this.errorsBulkLoad.length - 1]);

                    this.errorsBulkLoad.splice(-1, 1);
                    this.errorsBulkLoad.unshift("Carga masiva de infracciones cancelada.");
                }
            }
            this.showBulkLoadModal();
            this.oneClickBulkLoad = false;
        };
    }

    public createUploaderBulkLoadPay(): void {
        this.uploaderBulkLoadPay = new FileUploader({
            url: 'infraction/bulkLoadPay',
            /*allowedMimeType: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
             'image/jpeg', 'image/gif', 'image/png']*/
            allowedMimeType: VALID_MIME_TYPES,
            maxFileSize: FILE_MAX_SIZE
        });
        this.hasBulkLoadPayDropZoneOver = false;

        this.uploaderBulkLoadPay.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
            this.reportMessage = null;
            if (status == 200) {//OK
                let message = response.split("|");
                this.errorsBulkLoad = [];
                this.errorsBulkLoad[0] = message[0];

                if (message.length > 1) {
                    window.location.href = window.location.origin +
                        InfractionsService.getURLInfractionBulkload(message[1]);
                }
            } else if (status == 400) {//BAD_REQUEST
                if (response == "") {
                    this.errorsBulkLoad = [];
                    this.errorsBulkLoad[0] = "Archivo de carga masiva de infracciones no válido.";
                } else {
                    this.errorsBulkLoad = JSON.parse(response);

                    window.location.href = window.location.origin +
                        InfractionsService.getURLInfractionBulkload(this.errorsBulkLoad[this.errorsBulkLoad.length - 1]);

                    this.errorsBulkLoad.splice(-1, 1);
                    this.errorsBulkLoad.unshift("Carga masiva de infracciones cancelada.");
                }
            }
            this.showBulkLoadPayModal();
            this.oneClickBulkLoadPay = false;
        };
    }

    public createUploaderBulkLoadUpdate(): void {
        this.uploaderBulkLoadUpdate = new FileUploaderCustom({
            url: 'infraction/bulkLoadUpdate',
            /*allowedMimeType: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
             'image/jpeg', 'image/gif', 'image/png']*/
            allowedMimeType: VALID_MIME_TYPES,
            maxFileSize: FILE_MAX_SIZE
        });
        this.hasBulkLoadUpdateDropZoneOver = false;

        this.uploaderBulkLoadUpdate.onErrorItem = (item: any, response: any, status: any, headers: any) => {
            this.reportMessage = null;
            if (status == 400) {//BAD_REQUEST
                if (response == "") {
                    this.errorsBulkLoad = [];
                    this.errorsBulkLoad[0] = "Archivo de carga masiva de actualización de infracciones no válido.";
                } else {
                    this.errorsBulkLoad = JSON.parse(response);

                    window.location.href = window.location.origin +
                        InfractionsService.getURLInfractionBulkload(this.errorsBulkLoad[this.errorsBulkLoad.length - 1]);

                    this.errorsBulkLoad.splice(-1, 1);
                    this.errorsBulkLoad.unshift("Carga masiva de actualización de infracciones cancelada.");
                }
            }
            this.oneClickBulkLoadUpdate = false;
            this.showBulkLoadUpdateModal();
        };

        this.uploaderBulkLoadUpdate.onSuccessItem = (item: any, response: any, status: any, headers: any) => {
            this.reportMessage = null;
            if (status == 200) {//OK
                let message = response.split("|");
                this.errorsBulkLoad = [];
                this.errorsBulkLoad[0] = message[0];

                if (message.length > 1) {
                    window.location.href = window.location.origin +
                        InfractionsService.getURLInfractionBulkload(message[1]);
                }
            }
            this.loading = false;
            this.oneClickBulkLoadUpdate = false;
            this.showBulkLoadUpdateModal();
        };
    }

    public sendMail(item: Infraction, event: any): void {
        event.preventDefault();
        this.sendMailSuccess = false;
        this.sendMailError = false;
        item.sendingMail = true;
        this.infractionsService.sendMail(item).subscribe(
            () => {
                item.sendingMail = false;
                item.sent = true;
                this.sendMailSuccess = true;
            },
            (error) => {
                if (error.status == 501) {//NOT_IMPLEMENTED
                    this.bindError('Ocurrió un error al enviar mail.')
                }

                item.sendingMail = false;
                this.sendMailError = true;
            });
    }

    public fileOverBulkLoadPay(e: any): void {
        this.hasBulkLoadPayDropZoneOver = e;
    }

    public fileOverBulkLoad(e: any): void {
        this.hasBulkLoadDropZoneOver = e;
    }

    public enableMultipleFiles(): boolean {
        return false;
    }

    public ngAfterViewInit() {
        /*Limpieza de inputs al agregar a la cola el/los archivo/s*/
        this.uploaderBulkLoadPay.onAfterAddingFile = (
            () => {
                this.bulkLoadInfractionPay.nativeElement.value = '';
                this.reportMessage = null;
            });
        this.uploaderBulkLoad.onAfterAddingFile = (
            () => {
                this.bulkLoadInfraction.nativeElement.value = '';
                this.reportMessage = null;
            });
        this.uploaderBulkLoadUpdate.onAfterAddingFile = (
            () => {
                this.bulkLoadUpdateInfraction.nativeElement.value = '';
                this.reportMessage = null;
            });
    }

    public showBulkLoadPayModal(): void {
        this.bulkLoadInfractionPayModal.show();
        this.disableLoading();
    }

    public showBulkLoadModal(): void {
        this.bulkLoadInfractionModal.show();
        this.disableLoading();
        this.isBeforeUpload = false;
    }

    public showBulkLoadUpdateModal(): void {
        this.bulkLoadUpdateInfractionModal.show();
        this.disableLoading();
        this.isBeforeUpload = false;
    }

    public hideBulkLoadPayModal(): void {
        this.bulkLoadInfractionPayModal.hide();
        this.errorsBulkLoad = [];
    }

    public hideBulkLoadModal(): void {
        this.bulkLoadInfractionModal.hide();
        this.errorsBulkLoad = [];
        window.location.reload();
    }

    public hideBulkLoadUpdateModal(): void {
        this.bulkLoadUpdateInfractionModal.hide();
        this.errorsBulkLoad = [];
    }

    /**
     * MIGRACION
     * */
    public migrateActs(): void {
        this.infractionsService.migrateActs().subscribe(
            () => {
            },
            () => {
                this.bindError('Ocurrió un error con la migracion.')
            });
    }

    public imageNotFound(): void {
        this.infractionAct.nativeElement.setAttribute('src', this.imgNotFound.nativeElement.getAttribute('src'));
        this.infractionAct.nativeElement.setAttribute('height', 150);
        this.infractionAct.nativeElement.setAttribute('width', 150);
    }

    public disableLoading(): void {
        this.loading = false;
        this.oneClickBulkLoad = false;
        this.oneClickBulkLoadPay = false;
        this.oneClickBulkLoadUpdate = false;
    }

    public enableLoading(): void {
        this.loading = true;
    }

    public enableOneClickBulkload(): void {
        this.oneClickBulkLoad = true;
    }

    public enableOneClickBulkloadPay(): void {
        this.oneClickBulkLoadPay = true;
    }

    public enableOneClickBulkloadUpdate(): void {
        this.oneClickBulkLoadUpdate = true;
    }

    private bindError(messageError: string): void {
        this.loading = false;
        if (this.error == null) {
            this.error = messageError;
        } else {
            this.error = this.error.toString() + ' ' + messageError;
        }
    }

    public sortPage(): void {
        this.data.sort((a, b) => {

            if (this.sortMode) {
                //PAGA      -> 1
                //NO PAGA   -> 2
                //RESTO     -> 3

                if ((a.state.id == '1' || a.state.id == '2' || a.state.id == '3'))
                    this.pA = 1;
                else if (a.state.id == '5')
                    this.pA = 2;
                else
                    this.pA = 3;


                if ((b.state.id == '1' || b.state.id == '2' || b.state.id == '3'))
                    this.pB = 1;
                else if (b.state.id == '5')
                    this.pB = 2;
                else
                    this.pB = 3;

                return this.pA - this.pB;
            }
            else {
                //NO PAGA      -> 1
                //PAGA         -> 2
                //RESTO        -> 3

                if ((a.state.id == '1' || a.state.id == '2' || a.state.id == '3'))
                    this.pA = 2;
                else if (a.state.id == '5')
                    this.pA = 1;
                else
                    this.pA = 3;


                if ((b.state.id == '1' || b.state.id == '2' || b.state.id == '3'))
                    this.pB = 2;
                else if (b.state.id == '5')
                    this.pB = 1;
                else
                    this.pB = 3;

                return this.pA - this.pB;
            }
        })
    }

    public sortTable(sort: boolean): void {
        this.sortMode = sort;
        this.sortPage();
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/infractions/infractions.panel.component.ts
 **/